import { restHeartClient } from '..'

/**
 * 执行聚合查询。
 * @param db
 * @param collection
 * @param aggregateName
 * @param data
 */
export function aggregate(db: string, collection: string, aggregateName: string, data: any) {
	return restHeartClient.get(`${db}/${collection}/_aggrs/${aggregateName}`, { params: data })
}
